import dayjs from 'dayjs';
import 'dayjs/locale/da';
import isoWeek from 'dayjs/plugin/isoWeek';
import weekday from 'dayjs/plugin/weekday';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(isoWeek);
dayjs.extend(weekday);
dayjs.extend(advancedFormat);
dayjs.extend(localizedFormat);
dayjs.extend(updateLocale);

dayjs.updateLocale('da', {
  weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
  monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
});

export const formatTime = (date: Date, format = 'HH:mm'): string => dayjs(date).format(format);
export const getLocale = (): string => dayjs.locale();
export const setLocale = (locale: string): string => dayjs.locale(locale);
export const getThisYear = (): number => dayjs().year();
export const getYearToString = (date: Date): string => formatTime(date, 'YYYY');
export const getNumberOfWeeksInYear = (year: number): number => dayjs(`${year}-12-31`).isoWeek();
export const skipWeeks = (date: Date, multiplier: number): Date => dayjs(date).clone().add(multiplier * 7, 'days').toDate();
export const getWeek = (date: Date): number => dayjs(date).isoWeek();
// eslint-disable-next-line max-len
export const getDateByWeekday = (date: Date, index: number, locale = 'da'): Date => {
  const currentLocale = getLocale();
  setLocale(locale);
  const newDate = dayjs(date).weekday(index).toDate();
  if (currentLocale !== locale) {
    setLocale(currentLocale);
  }
  return newDate;
};
const dateIsSameMonthAsCurrent = (date: Date): boolean => formatTime(new Date(), 'M') === formatTime(date, 'M');
export const getLongDate = (date: Date): string => formatTime(date, 'dddd, Do MMMM YYYY');
export const getShortDate = (date: Date): string => formatTime(date, `ddd D${(dateIsSameMonthAsCurrent(date) ? '' : `${getLocale() === 'da' ? '.' : ''} MMM`)}`);
export const isToday = (date: Date): boolean => dayjs(date).isSame(dayjs());
export const multipleDaysFormatTime = (date: Date, index: number, format = 'ddd HH:mm', firstLetterToUpper = true): string => {
  if (index > 0) {
    const formatted = formatTime(date, format);
    if (firstLetterToUpper) {
      return formatted.charAt(0).toUpperCase() + formatted.slice(1);
    }
    return formatted;
  }
  return formatTime(date);
};
export const formatDayOfWeek = (date: Date): string => formatTime(date, 'dddd').charAt(0).toUpperCase() + formatTime(date, 'dddd').slice(1);
